import type {AgentBuilderActions} from 'src/action-creators/agent-builder';
import type {
  AgentConfig,
  ChannelSettings,
  SharedAllowedAttributes,
  ChannelApiBotSettings,
} from 'src/types/agent-builder';

import {
  RECEIVE_CHANNEL_SETTINGS,
  RECEIVE_AGENT_SUGGESTION,
  RECEIVE_ALLOWED_ATTRIBUTES,
  RECEIVE_AGENT_CONFIGURATION,
  RECEIVE_AGENT_API_BOT_CONFIGURATION,
} from 'src/action-creators/agent-builder';


interface AgentBuilderState {
  suggestion: string | null;
  selectedAgent: AgentConfig | null;
  channelSettings: ChannelSettings | null;
  allowedAttributes: SharedAllowedAttributes | null;
  apiBotConfiguration: Partial<ChannelApiBotSettings> | null;
}

const initialState: AgentBuilderState = {
  suggestion: null,
  selectedAgent: null,
  channelSettings: null,
  allowedAttributes: null,
  apiBotConfiguration: null,
};

export default (
  state: AgentBuilderState = initialState,
  action: AgentBuilderActions,
): AgentBuilderState => {
  switch (action.type) {
    case RECEIVE_CHANNEL_SETTINGS:
      return {
        ...state,
        channelSettings: action.payload,
        apiBotConfiguration: {
          ...(state.apiBotConfiguration || {}),
          ...(action.payload.api_bot || {}),
        },
      };
    case RECEIVE_AGENT_SUGGESTION:
      return {
        ...state,
        suggestion: action.payload,
      };
    case RECEIVE_ALLOWED_ATTRIBUTES:
      return {
        ...state,
        allowedAttributes: action.payload,
      };
    case RECEIVE_AGENT_CONFIGURATION:
      return {
        ...state,
        selectedAgent: action.payload
          ? {
              ...(state.selectedAgent || {}),
              ...action.payload,
            }
          : action.payload,
      };
    case RECEIVE_AGENT_API_BOT_CONFIGURATION:
      return {
        ...state,
        apiBotConfiguration: {
          ...(state.apiBotConfiguration || {}),
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
